import {
  finishRoundTrip,
  RoundTripExpired,
  useAuthStore,
  useErrorMessage,
} from '@sentinel/web-core';
import { Button, ErrorState } from '@sentinel/ui';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthFrame } from './AuthFrame';

/** Back from `accounts.`: the code and this tab's verifier open the console session. */
export function CallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const errorMessage = useErrorMessage();
  const applyGrant = useAuthStore((s) => s.applyGrant);
  const { code }: { code?: string } = useSearch({ strict: false });
  const [failure, setFailure] = useState<string | null>(null);

  useEffect(() => {
    finishRoundTrip(code)
      .then((grant) => {
        applyGrant(grant);
        void navigate({ to: '/', replace: true });
      })
      .catch((error: unknown) =>
        setFailure(
          error instanceof RoundTripExpired ? t('console.auth.expired') : errorMessage(error),
        ),
      );
  }, [code]);

  return (
    <AuthFrame>
      {failure === null ? (
        <div className="indet" role="progressbar" aria-label={t('console.auth.arriving')} />
      ) : (
        <ErrorState
          title={t('console.auth.failedTitle')}
          description={failure}
          action={
            <Button onClick={() => void navigate({ to: '/auth/start' })}>
              {t('common.actions.retry')}
            </Button>
          }
        />
      )}
    </AuthFrame>
  );
}
